import Icon from '../components/Icon.vue'

Icon.register({
  smoking: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M632 352c4.4 0 8 3.6 8 8v144c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-144c0-4.4 3.6-8 8-8h48zM553.3 87.1c54.3 36.4 86.7 97.1 86.7 162.6v30.3c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-30.3c0-50.2-25.2-96.7-67.4-124-18.4-12-28.6-33.4-28.6-55.4v-62.3c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v62.3c0 6.8 3.6 13 9.3 16.8zM432 352c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16h-384c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h384zM400 464v-64h-176v64h176zM487.7 141.6c35.3 24.7 56.3 64.8 56.3 108.1v30.3c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-30.3c0-27.4-13.3-52.9-35.7-68.6-35.7-25.1-60.3-63-60.3-106.7v-66.4c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v62.3c0 29 15.8 54.7 39.7 71.3zM536 352c4.4 0 8 3.6 8 8v144c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-144c0-4.4 3.6-8 8-8h48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/smoking.js
// module id = 1908
// module chunks = 0